import { createAction } from '../actions';
import { AppDispatch } from '../store';
import { ActionTypes } from './actionTypes';

export const updateIsLoaded = (isLoaded: boolean) => (dispatch: AppDispatch) => {
  dispatch(createAction(ActionTypes.SET_GOOGLE_MAPS_IS_LOADED, isLoaded));
};
